module.exports = __webpack_public_path__ + "img/1-3.0b6d1c01.jpg";